@if (hasContent()) {
    <section class="cs-panel" [attr.aria-labelledby]="title() ? headingId : null" data-cy="customer-success-panel">
        <sirius-container>
            @if (title(); as heading) {
                <h2 class="cs-panel__title" [id]="headingId" data-cy="title">{{ heading }}</h2>
            }
            @if (notice(); as noticeHtml) {
                <p class="cs-panel__notice" [innerHTML]="noticeHtml" data-cy="notice"></p>
            }
            @if (featured(); as featuredCard) {
                <div class="cs-panel__grid" [class.cs-panel__grid--single]="secondary().length === 0">
                    <ng-container
                        *ngTemplateOutlet="cardTemplate; context: { card: featuredCard, variant: 'featured' }" />
                    @if (secondary().length > 0) {
                        <div class="cs-panel__side">
                            @for (card of secondary(); track card.link.href) {
                                <ng-container *ngTemplateOutlet="cardTemplate; context: { card, variant: 'row' }" />
                            }
                        </div>
                    }
                </div>
            }
        </sirius-container>
    </section>
}

<!--
    One card markup for both variants. The featured card and the rows differ only in classes and photo sizes,
    and the grid needs the rows wrapped in their own column, which rules out a single @for.
-->
<ng-template #cardTemplate let-card="card" let-variant="variant">
    <article
        class="cs-panel__card"
        [class.cs-panel__card--featured]="variant === 'featured'"
        [class.cs-panel__card--row]="variant === 'row'"
        [class.sir-text-context-on-dark]="variant === 'row'"
        [attr.data-cy]="variant === 'featured' ? 'featured-card' : 'secondary-card'">
        <div class="cs-panel__media">
            <sirius-image-item
                class="cs-panel__photo"
                [image]="card.image"
                [imageData]="variant === 'featured' ? featuredPhoto : rowPhoto"
                [alt]="card.image.title"
                objectFit="cover" />
        </div>
        <div class="cs-panel__body">
            <h3 class="cs-panel__company" data-cy="company">{{ card.company }}</h3>
            @if (card.descriptionHtml; as description) {
                <div class="cs-panel__description" [innerHTML]="description" data-cy="description"></div>
            }
            <a class="cs-panel__cta sir-text-style-link-m-default" [siriusLink]="card.link" data-cy="cta">
                {{ ctaText() }}<span class="cs-panel__cta-context">: {{ card.company }}</span>
                <sirius-icon name="arrow_right_small" aria-hidden="true" />
            </a>
        </div>
    </article>
</ng-template>
